import { render, staticRenderFns } from "./PaymentRecordsChart.vue?vue&type=template&id=df30fd5c&scoped=true"
import script from "./PaymentRecordsChart.vue?vue&type=script&lang=js"
export * from "./PaymentRecordsChart.vue?vue&type=script&lang=js"
import style0 from "./PaymentRecordsChart.vue?vue&type=style&index=0&id=df30fd5c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df30fd5c",
  null
  
)

export default component.exports